import { render, staticRenderFns } from "./Depreciation.vue?vue&type=template&id=225b17e7&scoped=true"
import script from "./Depreciation.vue?vue&type=script&lang=js"
export * from "./Depreciation.vue?vue&type=script&lang=js"
import style0 from "./Depreciation.vue?vue&type=style&index=0&id=225b17e7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225b17e7",
  null
  
)

export default component.exports